// Homepage "team" (client reviews) defaults (EN + FR): today's text. Logos are not here:
// the built-in logos in src/Sections/Team are the fallback, matched by reviewer name.
const TEAM_DEFAULTS = {
  "en": {
    "eyebrow": "Testimonials",
    "title": "What People Say About Vision",
    "items": [
      {
        "quote": "Very great company, if not the best in the field.",
        "name": "Arnaud Bellemare",
        "role": "Property Manager",
        "company": "Ascentia",
        "alt": "Ascentia property management review logo – 5-star client review of Vision Security in Montreal"
      },
      {
        "quote": "Fantastic service, great team! Vision Security has been our trusted partner for equipment site protection. Their guards are vigilant, professional, and understand the unique challenges of our industry.",
        "name": "Johnny Makris",
        "role": "CEO",
        "company": "Loc Equip",
        "alt": "Loc Equip review logo – 5-star construction site security client review of Vision Security"
      },
      {
        "quote": "We work with this company, and their professionalism is impeccable. We have never regretted choosing them. Our collaboration with the agent Mamadou is exceptional: he is serious, competent, and highly professional in his work.",
        "name": "Celina Bouatmane",
        "role": "Director",
        "company": "Otika Services",
        "alt": "Otika Services review logo – 5-star client review of Vision Security in Montreal, Quebec"
      },
      {
        "quote": "What truly stood out was their unwavering commitment to customer satisfaction. They went above and beyond to address all my concerns and questions, providing comprehensive solutions that left no room for doubt or misunderstanding. This company has my full respect and support.",
        "name": "Edouard Wanadi",
        "role": "Law Enforcement Officer",
        "company": "Royal Canadian Mounted Police",
        "alt": "RCMP review logo – 5-star Royal Canadian Mounted Police review of Vision Security"
      },
      {
        "quote": "Very professional atmosphere from the employees and management. Vision Security maintains the high standards we expect and their team integrates seamlessly with our security protocols.",
        "name": "Kobe Archer",
        "role": "Master Corporal",
        "company": "Canadian Armed Forces",
        "alt": "Canadian Armed Forces review logo – 5-star military review of Vision Security"
      },
      {
        "quote": "Vision Sécurité Inc. is a group of professional and knowledgeable agents. They are punctual, alert and well versed in the event industry. They have been a great addition to our team and we highly recommend them.",
        "name": "Leilani Baja",
        "role": "Director of Finances & Operations",
        "company": "Le Windsor",
        "alt": "Le Windsor hotel review logo – 5-star hospitality client review of Vision Security in Montreal"
      },
      {
        "quote": "Just wrapped up a great event with this company. Happy with all the security guards they sent. Recommend.",
        "name": "Martin Riviere",
        "role": "Event Coordinator",
        "company": "Comexposium",
        "alt": "Comexposium review logo – 5-star event client review of Vision Security in Toronto"
      },
      {
        "quote": "We've been working with Vision Sécurité for our company's security needs and have been very pleased with their service so far. The team is professional, responsive, and reliable. Communication is always clear and they've been proactive in ensuring everything runs smoothly. Thank you to Renzo and the entire team for your continued support—highly recommend!",
        "name": "Athena Nikolakakis",
        "role": "CPA Auditor Controller",
        "company": "GoTransport"
      }
    ]
  },
  "fr": {
    "eyebrow": "Témoignages",
    "title": "Ce que les gens disent de Vision",
    "items": [
      {
        "quote": "Excellente entreprise, peut-être la meilleure du secteur.",
        "name": "Arnaud Bellemare",
        "role": "Gestionnaire immobilier",
        "company": "Ascentia",
        "alt": "Ascentia property management review logo – 5-star client review of Vision Security in Montreal"
      },
      {
        "quote": "Service fantastique, excellente équipe ! Vision Security est notre partenaire de confiance pour la protection de nos sites d’équipement. Leurs agents sont vigilants, professionnels et comprennent les défis de notre industrie.",
        "name": "Johnny Makris",
        "role": "PDG",
        "company": "Loc Equip",
        "alt": "Loc Equip review logo – 5-star construction site security client review of Vision Security"
      },
      {
        "quote": "Nous travaillons avec cette compagnie et leur professionnalisme est irréprochable. Nous n’avons jamais regretté notre choix. Notre collaboration avec l’agent Mamadou est exceptionnelle : il est sérieux, compétent et d’un grand professionnalisme.",
        "name": "Celina Bouatmane",
        "role": "Directrice",
        "company": "Otika Services",
        "alt": "Otika Services review logo – 5-star client review of Vision Security in Montreal, Quebec"
      },
      {
        "quote": "Ce qui m’a surtout marqué est leur engagement indéfectible envers la satisfaction du client. Ils ont dépassé les attentes pour répondre à toutes mes questions et préoccupations, offrant des solutions complètes et rassurantes. Cette entreprise a tout mon respect et mon soutien.",
        "name": "Edouard Wanadi",
        "role": "Agent des forces de l’ordre",
        "company": "Gendarmerie royale du Canada",
        "alt": "RCMP review logo – 5-star Royal Canadian Mounted Police review of Vision Security"
      },
      {
        "quote": "Atmosphère très professionnelle, tant chez les employés que chez la direction. Vision Security maintient les standards élevés que nous attendons, et leur équipe s’intègre parfaitement à nos protocoles de sécurité.",
        "name": "Kobe Archer",
        "role": "Caporal-chef",
        "company": "Forces armées canadiennes",
        "alt": "Canadian Armed Forces review logo – 5-star military review of Vision Security"
      },
      {
        "quote": "Vision Sécurité Inc. regroupe des agents professionnels et expérimentés. Ils sont ponctuels, vigilants et connaissent très bien l’industrie de l’événementiel. Une valeur ajoutée pour notre équipe que nous recommandons vivement.",
        "name": "Leilani Baja",
        "role": "Directrice des finances et des opérations",
        "company": "Le Windsor",
        "alt": "Le Windsor hotel review logo – 5-star hospitality client review of Vision Security in Montreal"
      },
      {
        "quote": "Nous venons de terminer un excellent événement avec cette compagnie. Très satisfaits des agents envoyés. Recommandé.",
        "name": "Martin Riviere",
        "role": "Coordonnateur d’événements",
        "company": "Comexposium",
        "alt": "Comexposium review logo – 5-star event client review of Vision Security in Toronto"
      },
      {
        "quote": "Nous collaborons avec Vision Sécurité pour les besoins de sécurité de notre entreprise et nous en sommes très satisfaits. L’équipe est professionnelle, réactive et fiable. La communication est claire et ils sont proactifs pour que tout se déroule sans accroc. Merci à Renzo et à toute l’équipe — fortement recommandé !",
        "name": "Athena Nikolakakis",
        "role": "CPA, auditrice et contrôleuse",
        "company": "GoTransport"
      }
    ]
  }
};

export default TEAM_DEFAULTS;
